var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.5787,
    height: 31.8035,
    rx: 1.87079,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 20.7445 0.776306)",
    fill: "url(#paint0_linear_92_28072)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5076 30.5946C28.3564 31.2462 27.8598 31.7951 27.1687 31.9803L10.9052 36.3381C9.90722 36.6055 8.8814 36.0132 8.61398 35.0152L1.35103 7.90953C1.08361 6.91152 1.67587 5.8857 2.67388 5.61828L2.73811 5.60107C2.671 5.89031 2.67196 6.19977 2.75417 6.50659L10.0171 33.6123C10.2845 34.6103 11.3104 35.2026 12.3084 34.9352L28.5076 30.5946Z",
    fill: "url(#paint1_linear_92_28072)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2213,
    y: 2.65344,
    width: 20.5787,
    height: 31.8035,
    rx: 1.87079,
    transform: "rotate(7.30662 14.2213 2.65344)",
    fill: "url(#paint2_linear_92_28072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4465 33.0007C10.6173 33.7422 11.2335 34.3342 12.0322 34.4366L28.7326 36.5779C29.7575 36.7094 30.6948 35.9851 30.8262 34.9603L34.3951 7.12624C34.5185 6.16341 33.8867 5.27783 32.9599 5.06525C33.0083 5.27506 33.0209 5.49685 32.9919 5.72289L29.423 33.5569C29.2916 34.5817 28.3543 35.306 27.3295 35.1746L10.6291 33.0333C10.5671 33.0253 10.5062 33.0144 10.4465 33.0007Z",
    fill: "url(#paint3_linear_92_28072)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.37378,
    y: 5.70392,
    width: 20.5787,
    height: 31.8035,
    rx: 1.87079,
    fill: "#53C1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53918 36.4065C8.83272 37.0556 9.48594 37.5072 10.2447 37.5072H27.0818C28.115 37.5072 28.9526 36.6697 28.9526 35.6364V7.57455C28.9526 6.81584 28.5009 6.16262 27.8518 5.86908C27.958 6.10393 28.0172 6.36462 28.0172 6.63912V35.6364C28.0172 36.153 27.5984 36.5718 27.0818 36.5718H9.30922C9.03472 36.5718 8.77403 36.5127 8.53918 36.4065Z",
    fill: "#2387BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0817 5.70392H10.2446C9.21136 5.70392 8.37378 6.5415 8.37378 7.57471V31.895L28.9525 14.1225V7.57471C28.9525 6.5415 28.1149 5.70392 27.0817 5.70392Z",
    fill: "#81D1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37378 20.2025L20.0662 9.66266L8.37378 17.864V20.2025Z",
    fill: "#53C1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1463 6.63934H10.2446C9.728 6.63934 9.3092 7.05813 9.3092 7.57474V34.7012",
    stroke: "#BEE7FF",
    strokeWidth: 0.935397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3092 9.91315V14.5901",
    stroke: "#FFFDFA",
    strokeWidth: 0.935397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8932 20.2418C13.7249 20.2759 13.5888 20.3995 13.5387 20.5638C13.4886 20.728 13.5326 20.9065 13.6532 21.0287L15.8178 23.2222L15.2811 25.9414C15.2465 26.1169 15.315 26.2967 15.4575 26.4048C15.6001 26.5128 15.7918 26.53 15.9513 26.4492L18.6631 25.0752L21.3748 26.4492C21.5344 26.53 21.726 26.5128 21.8686 26.4048C22.0112 26.2967 22.0797 26.1169 22.045 25.9414L21.5083 23.2222L23.6729 21.0287C23.7936 20.9065 23.8375 20.728 23.7874 20.5638C23.7373 20.3995 23.6012 20.2759 23.4329 20.2418L20.7135 19.6907L19.0655 16.9074C18.9813 16.7652 18.8283 16.678 18.6631 16.678C18.4978 16.678 18.3448 16.7652 18.2606 16.9074L17.3837 18.3884L16.6126 19.6907L13.8932 20.2418Z",
    fill: "#67DBFF",
    stroke: "#2481B6",
    strokeWidth: 0.935397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8569 21.1212L17.7277 20.6535L18.6631 19.0165",
    stroke: "#E5FDFF",
    strokeWidth: 0.935397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_92_28072",
    x1: 10.2894,
    y1: 0,
    x2: 10.2894,
    y2: 31.8035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_92_28072",
    x1: 14.8972,
    y1: 5.60107,
    x2: 14.8972,
    y2: 36.4023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_92_28072",
    x1: 24.5107,
    y1: 2.65344,
    x2: 24.5107,
    y2: 34.4569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6FF35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#649920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_92_28072",
    x1: 22.4285,
    y1: 5.06525,
    x2: 22.4285,
    y2: 36.5933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#355F00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.5228672b3503cd1713fccb1dd4249cb6.svg";
export { ForwardRef as ReactComponent };